export default [
  {
    path: '/real-estate-developments-settings/characteristics',
    name: 'CharacteristicsList',
    component: () => import('pages/real-estate-developments-settings/characteristics/CharacteristicsList.vue')
  },
  {
    path: '/real-estate-developments-settings/characteristics/new',
    name: 'CharacteristicsCreate',
    component: () => import('pages/real-estate-developments-settings/characteristics/CharacteristicsForm.vue')
  },
  {
    path: '/real-estate-developments-settings/characteristics/:id',
    name: 'CharacteristicsSingle',
    component: () => import('pages/real-estate-developments-settings/characteristics/CharacteristicsSingle.vue')
  },
  {
    path: '/real-estate-developments-settings/characteristics/:id/edit',
    name: 'CharacteristicsEdit',
    component: () => import('pages/real-estate-developments-settings/characteristics/CharacteristicsForm.vue')
  }
]
